import React from "react";
import facebookLogo from "../../assets/facebook-logo.png";
import gmailLogo from "../../assets/gmail-logo.png";
import googleLogo from "../../assets/google-logo.png";
import instagramLogo from "../../assets/instagram-logo.png";
import n8nLogo from "../../assets/n8n-logo.png";
import notionLogo from "../../assets/notion-logo.png";
import openaiLogo from "../../assets/openai-logo.png";
import slackLogo from "../../assets/slack-logo.png";

import "../../styles/IntegratedWithSection.css";

const IntegratedWithSection = () => {
    return (
        <>
            <div className="visionary-section">
                <div className="visionary-content">
                    <div className="text-content" data-aos="fade-right">
                        <h2 className="visionary-title">We Build Automations That Actually Work</h2>
                        <p className="visionary-description">
                            At <strong>Brand Bounce</strong>, we design custom automations that eliminate manual work,
                            streamline operations, and help businesses scale faster — without adding overhead.
                            From onboarding to lead gen, content to reporting, we bring together strategy, AI, and the
                            tools you already use to deliver real growth.
                        </p>
                    </div>
                    <div className="visionary-image" data-aos="fade-left">
                        <img src="/illustration.png" alt="Automation System Illustration" />
                    </div>
                </div>
            </div>

            <div className="integrated-section">
                <h2 className="integrated-title">Built With the Tools You Already Use</h2>
                <p className="integrated-description">
                    We integrate with the platforms that power your business — and turn them into a fully automated system.
                </p>
                <div className="integrated-logos">
                    <img src={slackLogo} alt="Slack" className="integrated-logo" />
                    <img src={gmailLogo} alt="Gmail" className="integrated-logo" />
                    <img src={notionLogo} alt="Notion" className="integrated-logo" />
                    <img src={googleLogo} alt="Google" className="integrated-logo" />
                    <img src={facebookLogo} alt="Facebook" className="integrated-logo" />
                    <img src={instagramLogo} alt="Instagram" className="integrated-logo" />
                    <img src={openaiLogo} alt="OpenAI" className="integrated-logo" />
                    <img src={n8nLogo} alt="n8n" className="integrated-logo" />
                </div>
            </div>
        </>
    );
};

export default IntegratedWithSection;
